import NHead from 'next/head';

const Head = () => (
  <NHead>
    <title>Powered by Foam</title>
    <link rel="icon" href="/favicon/favicon.svg?v=5" type="image/svg+xml" />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="/favicon/apple-touch-icon.png?v=5"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="32x32"
      href="/favicon/favicon-32x32.png?v=5"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="16x16"
      href="/favicon/favicon-16x16.png?v=5"
    />
    <link rel="manifest" href="/favicon/site.webmanifest?v=5" />
    <link
      rel="mask-icon"
      href="/favicon/safari-pinned-tab.svg?v=5"
      color="#1c2128"
    />
    <link rel="shortcut icon" href="/favicon/favicon.ico?v=5" />
    <meta name="apple-mobile-web-app-title" content="Foam " />
    <meta name="application-name" content="Foam " />
    <meta name="msapplication-TileColor" content="#2d89ef" />
    <meta
      name="msapplication-config"
      content="/favicon/browserconfig.xml?v=5"
    />
    <meta name="theme-color" content="#ffffff" />
    <meta name="robots" content="noindex,nofollow" />
  </NHead>
);

export default Head;
